import { queryPage } from '../shared/technical/rest/restApi';
import { PagedResult, Pageable } from '../shared/technical/rest/pageable';
import { MeterType } from './MeterType';
import { AxiosInstance } from 'axios';

export function getMeterTypesForCategory(customAxios: AxiosInstance, pageable: Pageable, categoryId: string): Promise<PagedResult<MeterType>> {
  return queryPage<MeterType>(customAxios, 'meter-types', pageable, 'categoryId=' + categoryId);
}
